var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path6, _circle3, _path7, _circle4, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydrogen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1050,
    height: 424,
    viewBox: "0 0 1050 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 939.166,
    cy: 358.947,
    r: 57.0566,
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 924.979,
    cy: 358.947,
    r: 57.0566,
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.76 416.004C427.271 416.004 452.816 390.459 452.816 358.947C452.816 327.436 427.271 301.891 395.76 301.891C364.248 301.891 338.703 327.436 338.703 358.947C338.703 390.459 364.248 416.004 395.76 416.004Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M381.588 416.004C413.099 416.004 438.644 390.459 438.644 358.947C438.644 327.436 413.099 301.891 381.588 301.891C350.076 301.891 324.531 327.436 324.531 358.947C324.531 390.459 350.076 416.004 381.588 416.004Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.781 211.773V83.4717C211.781 60.8302 241.97 8 270.394 8H536.492C565.238 8 590.664 24.8752 613.75 40.1975C632.945 52.9374 650.522 64.6038 667.046 64.6038H985.366C1041.97 64.6038 1041.97 117.434 1041.97 117.434V211.774V355.17H211.781V211.774V211.773Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M613.75 40.1975L618.174 33.532L618.174 33.532L613.75 40.1975ZM1041.97 355.17V363.17H1049.97V355.17H1041.97ZM211.781 355.17H203.781V363.17H211.781V355.17ZM203.781 83.4717V211.773H219.781V83.4717H203.781ZM270.394 0C260.827 0 251.91 4.40428 244.335 10.2921C236.684 16.2388 229.712 24.2231 223.85 32.6924C217.969 41.1905 213.022 50.4411 209.521 59.1408C206.083 67.6837 203.781 76.3315 203.781 83.4717H219.781C219.781 79.2912 221.253 72.8446 224.364 65.1139C227.412 57.54 231.788 49.3378 237.007 41.7982C242.245 34.2298 248.15 27.5914 254.154 22.9249C260.233 18.1995 265.748 16 270.394 16V0ZM536.492 0H270.394V16H536.492V0ZM618.174 33.532C595.549 18.5155 568.078 0 536.492 0V16C562.399 16 585.779 31.2349 609.326 46.863L618.174 33.532ZM667.046 56.6038C660.608 56.6038 653.405 54.3118 645.028 50.0485C636.66 45.7892 627.87 39.9673 618.174 33.532L609.326 46.863C618.825 53.1677 628.421 59.5489 637.771 64.3078C647.113 69.0626 656.96 72.6038 667.046 72.6038V56.6038ZM985.366 56.6038H667.046V72.6038H985.366V56.6038ZM1041.97 117.434C1049.97 117.434 1049.97 117.43 1049.97 117.425C1049.97 117.423 1049.97 117.418 1049.97 117.415C1049.97 117.408 1049.97 117.399 1049.97 117.391C1049.97 117.373 1049.97 117.352 1049.97 117.328C1049.97 117.279 1049.97 117.218 1049.97 117.144C1049.96 116.997 1049.96 116.799 1049.95 116.555C1049.93 116.067 1049.9 115.391 1049.84 114.553C1049.71 112.881 1049.46 110.549 1048.96 107.773C1047.98 102.257 1045.99 94.7923 1041.95 87.2411C1037.88 79.648 1031.68 71.8935 1022.32 66.066C1012.93 60.2235 1000.81 56.6038 985.366 56.6038V72.6038C998.226 72.6038 1007.33 75.5879 1013.86 79.6509C1020.42 83.7291 1024.83 89.1822 1027.84 94.7966C1030.87 100.453 1032.43 106.196 1033.21 110.586C1033.6 112.763 1033.79 114.558 1033.88 115.774C1033.93 116.381 1033.95 116.84 1033.96 117.126C1033.97 117.269 1033.97 117.368 1033.97 117.421C1033.97 117.447 1033.97 117.461 1033.97 117.464C1033.97 117.465 1033.97 117.463 1033.97 117.458C1033.97 117.456 1033.97 117.452 1033.97 117.448C1033.97 117.446 1033.97 117.443 1033.97 117.442C1033.97 117.438 1033.97 117.434 1041.97 117.434ZM1049.97 211.774V117.434H1033.97V211.774H1049.97ZM1033.97 211.774V355.17H1049.97V211.774H1033.97ZM1041.97 347.17H211.781V363.17H1041.97V347.17ZM219.781 355.17V211.774H203.781V355.17H219.781ZM219.781 211.774V211.773H203.781V211.774H219.781Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 83.4717V211.774H838.189V117.434C838.189 117.434 838.189 64.6038 781.585 64.6038H463.265C426.868 64.6038 385.359 8 332.711 8H66.6123C38.1887 8 8 60.8302 8 83.4717Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 16,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 211.773,
    width: 830.189,
    height: 143.396,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 211.773,
    width: 830.189,
    height: 143.396,
    stroke: "black",
    strokeWidth: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 211.773,
    width: 830.189,
    height: 143.396,
    stroke: "black",
    strokeWidth: 16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 196.672,
    y: 121.211,
    width: 143.396,
    height: 113.208,
    rx: 16,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1875,
    y: 121.211,
    width: 143.396,
    height: 113.208,
    rx: 16,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 355.172,
    y: 121.211,
    width: 143.396,
    height: 113.208,
    rx: 16,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 513.656,
    y: 121.211,
    width: 143.396,
    height: 113.208,
    rx: 16,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 672.156,
    y: 121.211,
    width: 143.396,
    height: 113.208,
    rx: 16,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 872.375,
    y: 125.211,
    width: 135.396,
    height: 105.208,
    rx: 12,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 872.375,
    y: 87.4688,
    width: 135.396,
    height: 14.6415,
    rx: 7.32076,
    fill: "black",
    stroke: "black",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M868.375 270.502C868.375 259.938 878.432 252.273 888.618 255.074L926.67 265.539C928.052 265.919 929.479 266.112 930.912 266.112H956.486C958.113 266.112 959.731 265.863 961.283 265.375L990.974 256.044C1001.28 252.804 1011.77 260.503 1011.77 271.308V316.527C1011.77 325.363 1004.61 332.527 995.771 332.527H884.375C875.538 332.527 868.375 325.363 868.375 316.527V270.502Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.385,
    cy: 358.947,
    r: 57.0566,
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.994 416.004C223.506 416.004 249.051 390.459 249.051 358.947C249.051 327.436 223.506 301.891 191.994 301.891C160.483 301.891 134.938 327.436 134.938 358.947C134.938 390.459 160.483 416.004 191.994 416.004Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.213,
    cy: 358.947,
    r: 57.0566,
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.807 416.004C209.318 416.004 234.863 390.459 234.863 358.947C234.863 327.436 209.318 301.891 177.807 301.891C146.295 301.891 120.75 327.436 120.75 358.947C120.75 390.459 146.295 416.004 177.807 416.004Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrogen);
export default __webpack_public_path__ + "static/media/hydrogen.1c43ad183870fdc30fbcb2645dafde4f.svg";
export { ForwardRef as ReactComponent };